import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { isEmpty } from "./browserHelpers";
import { ApiResponse } from "app/bus/type";
// import {
//   invalidSession,
//   isMobileSite,
//   checkDeviceType,
// } from "./utils/generalUtils";

type ContentType =
  | "application/json"
  | "application/x-www-form-urlencoded"
  | string;

export const apiHelper = async <T>(
  url: string,
  method: "GET" | "POST" | "PUT" | "DELETE",
  payload?: Record<string, any>,

  contentType?: ContentType,
  requestHeaders?: Record<string, any>,
  config?: AxiosRequestConfig,
  AcceptType = "application/json"
): Promise<ApiResponse<T>> => {
  try {
    const commonHeaders = {
      Accept: AcceptType,
      "Content-Type": contentType,
      // "Preferred-Language": getCookie("lp") || "",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
      "app-agent": "DESKTOP",
      "X-CT-SOURCE": "ACCOUNT",
    };

    const headers = isEmpty(requestHeaders)
      ? commonHeaders
      : { ...commonHeaders, ...requestHeaders };

    const responseData: ApiResponse<T> = await axios.request({
      url,
      method,
      data: payload,
      headers,
      ...config,
    });

    return responseData;
  } catch (e) {
    // if (
    //   e?.response?.status === 401 &&
    //   e?.response?.data?.message === "INVALID_SESSION"
    // ) {
    //   invalidSession();
    // }
    // //setSentryError(e)
    return e as AxiosResponse;
  }
};

export const getApiDomain = () => {
  const isStaging = process.env.NEXT_PUBLIC_CT_ENV !== "production";

  if (isStaging) {
    return "https://qa2new.cleartrip.com";
  } else {
    return "https://www.cleartrip.com";
  }
};

export const getRouteHandlerDomain = () => {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3000";
  } else return getApiDomain();
};
